import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '群名称',
      clearable: true,
      placeholder: '请输入群名称'
    },
    {
      field: 'msgTime',
      type: 'datepicker',
      label: '消息时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
